module.exports={
	"Form": "CoreEditManifest",
	"Scope": "Core-Edit",
	"Descriptors":
	{
		"CoreDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Core-Edit-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Core-Edit-Identity",
				"Group": "Core-Edit-Identity"
			}
		},
		"CoreDetails.IDLot":
		{
			"Name": "Lot",
			"Hash": "Core-Edit-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details",
				"Entity": "Lot",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"CoreDetails.IDSublot":
		{
			"Name": "IDSublot",
			"Hash": "Core-Edit-IDSublot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.IDSample":
		{
			"Name": "Sample",
			"Hash": "Core-Edit-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"CoreDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Core-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"CoreDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Core-Edit-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Core-Edit-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.SublotName":
		{
			"Name": "Sublot Name",
			"Hash": "Core-Edit-SublotName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Core-Edit-Details",
				"Group": "Core-Edit-Details"
			}
		},
		"CoreDetails.IDCore":
		{
			"Name": "IDCore",
			"Hash": "Core-Edit-IDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.GUIDCore":
		{
			"Name": "GUIDCore",
			"Hash": "Core-Edit-GUIDCore",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Core-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Core-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Core-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		},
		"CoreDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Core-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Core-Edit-DataAudit",
				"Group": "Core-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Core-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Core-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Core-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Core-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Core-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Core-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
